/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Box, Card, Text, VStack, Table, Tbody, Th, TableContainer } from '@chakra-ui/react';
import { ModuleProduct } from '../../ModulesSuperApp/steps/forms/FormCreate';
import { FormCreate } from '../../ModulesSuperApp/steps/forms/FormCreate';
import HeaderTable from './atoms/HeaderTable';
import { IntegrationPlanRow } from './atoms/IntegrationPlanRow';

// Interface para planos ERP
interface IPlanERP {
  id: number;
  id_plan: number;
  name_plan: string;
  value_plan: number;
  count_clients_active: number;
  erp: string;
  count_clients: number;
}

interface Step2BenefitsProps {
  products: ModuleProduct[];
  filteredAndSortedProductsERP: IPlanERP[];
  sortOrder?: 'asc' | 'desc' | null;
  setSortOrder?: (order: 'asc' | 'desc' | null) => void;
  refetch?: () => void;
  createRef?: React.RefObject<{
    open: (data?: ModuleProduct, options?: { showBenefitsSelector?: boolean; benefit?: any }) => void;
    close: () => void;
  } | null>;
  clientsSortOrder?: 'asc' | 'desc' | null;
  setClientsSortOrder?: (order: 'asc' | 'desc' | null) => void;
  hasListFilter?: boolean;
}

export const Step2Benefits: React.FC<Step2BenefitsProps> = ({
  products,
  filteredAndSortedProductsERP,
  refetch,
  createRef,
  sortOrder,
  setSortOrder,
  clientsSortOrder,
  setClientsSortOrder,
  hasListFilter = false,
}) => {
  if (
    !filteredAndSortedProductsERP ||
    !Array.isArray(filteredAndSortedProductsERP) ||
    filteredAndSortedProductsERP.length === 0
  ) {
    return (
      <Text fontSize="sm" color="gray.500" textAlign="center" py={4}>
        Nenhum plano encontrado com os critérios de busca
      </Text>
    );
  }

  // Calcular quantidade de produtos SVAs para agrupamento
  const svasCount = products.length;

  return (
    <VStack spacing={2} width="100%">
      <Card width="100%" boxShadow="sm">
        <TableContainer maxH="70vh" overflowY="auto" position="relative">
          <Table variant="simple" size="sm">
            <HeaderTable
              sortOrder={sortOrder}
              setSortOrder={setSortOrder}
              clientsSortOrder={clientsSortOrder}
              setClientsSortOrder={setClientsSortOrder}
              grouping={{
                svas: svasCount
              }}
            >
              {products.map((product) => {
                const isContracted = product.active;
                return (
                  <Th
                    key={product.name}
                    fontSize="xs"
                    color="gray.700"
                    fontWeight="bold"
                    textTransform="uppercase"
                    textAlign="center"
                    width="150px"
                    minW="150px"
                    maxW="150px"
                    bg="gray.50"
                    opacity={isContracted ? 1 : 0.5}
                    borderRight="1px solid"
                    borderColor="gray.200"
                  >
                    <Box
                      display="flex"
                      flexDirection="column"
                      alignItems="center"
                      justifyContent="center"
                      p={2}
                      cursor="pointer"
                      onClick={() => createRef?.current?.open(product, { showBenefitsSelector: true })}
                      _hover={{ bg: 'gray.100' }}
                      borderRadius="md"
                      width="100%"
                      overflow="hidden"
                      wordBreak="break-word"
                    >
                      <Box
                        width="40px"
                        height="40px"
                        mb={2}
                        borderRadius="md"
                        overflow="hidden"
                        bg="white"
                        border="1px solid"
                        borderColor="gray.200"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <img
                          src={(product.metadata?.logo?.value as string) || ''}
                          alt={product.name}
                          style={{
                            width: '30px',
                            height: '30px',
                            objectFit: 'contain',
                          }}
                        />
                      </Box>
                      <Text fontSize="xs" fontWeight="bold" color="gray.800" textAlign="center" noOfLines={2} width="100%">
                        {product.name}
                      </Text>
                    </Box>
                  </Th>
                );
              })}
            </HeaderTable>

            <Tbody>
              {filteredAndSortedProductsERP.map((productERP: any) => (
                <IntegrationPlanRow
                  key={productERP.id}
                  productERP={productERP}
                  hasSvas={true}
                  allContrated={true}
                  refetch={refetch || (() => {})}
                  products={products as unknown as any}
                  hasListFilter={hasListFilter}
                  visiblePlans={hasListFilter ? (filteredAndSortedProductsERP as any) : undefined}
                />
              ))}
            </Tbody>
          </Table>
        </TableContainer>
      </Card>

      {/* Modal de criação de produtos */}
      {createRef && <FormCreate existingModules={products} createRef={createRef} refetch={refetch || (() => {})} />}
    </VStack>
  );
};
